<template>
    <div>
        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.acessoPolpaDentaria"
                    :validations="validations.acessoPolpaDentaria"
                    name="Quantidade"
                    :disabled="isDisabled && model.procedimentosQuantidade.acessoPolpaDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Acesso a polpa dentária e medicação (por dente)
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.adaptacaoProteseDentaria"
                    :validations="validations.adaptacaoProteseDentaria"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.adaptacaoProteseDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Adaptação de Prótese Dentária </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.aplicacaoCariostatico"
                    :validations="validations.aplicacaoCariostatico"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.aplicacaoCariostatico == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Aplicação de cariostático (por dente) </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.aplicacaoSelante"
                    :validations="validations.aplicacaoSelante"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.aplicacaoSelante == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Aplicação de selante (por dente) </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.aplicacaoTopicaFluor"
                    :validations="validations.aplicacaoTopicaFluor"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.aplicacaoTopicaFluor == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Aplicação tópica de flúor (individual por sessão)
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.capeamentoPulpar"
                    :validations="validations.capeamentoPulpar"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.capeamentoPulpar == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Capeamento pulpar </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.cimentacaoProtese"
                    :validations="validations.cimentacaoProtese"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.cimentacaoProtese == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Cimentação de prótese </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.curativoDemora"
                    :validations="validations.curativoDemora"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.curativoDemora == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Curativo de demora com ou sem preparo biomecânico
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.drenagemAbscesso"
                    :validations="validations.drenagemAbscesso"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.drenagemAbscesso == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Drenagem de abscesso </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.evidenciacaoPlacaBacteriana"
                    :validations="validations.evidenciacaoPlacaBacteriana"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.evidenciacaoPlacaBacteriana == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Evidenciação de placa bacteriana</rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.exodontiaDenteDeciduo"
                    :validations="validations.exodontiaDenteDeciduo"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.exodontiaDenteDeciduo == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Exodontia de dente decíduo</rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.exodontiaDentePermanente"
                    :validations="validations.exodontiaDentePermanente"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.exodontiaDentePermanente == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Exodontia de dente permanente</rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.instalacaoProteseDentaria"
                    :validations="validations.instalacaoProteseDentaria"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.instalacaoProteseDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Instalação de prótese dentária</rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.moldagemProteseDentaria"
                    :validations="validations.moldagemProteseDentaria"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.moldagemProteseDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Moldagem dento-gengival para contrução de prótese dentária
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.orientacaoHigieneBucal"
                    :validations="validations.orientacaoHigieneBucal"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.orientacaoHigieneBucal == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Orientação de Higiene Bucal</rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.remocaoPlacaBacteriana"
                    :validations="validations.remocaoPlacaBacteriana"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.remocaoPlacaBacteriana == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Profilaxia/Remoção de placa bacteriana</rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.pulpotomiaDentaria"
                    :validations="validations.pulpotomiaDentaria"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.pulpotomiaDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5"> Pulpotomia dentária</rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.raspagemSupragengivais"
                    :validations="validations.raspagemSupragengivais"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.raspagemSupragengivais == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Raspagem alisamento e polimento supregengivais (por sextante)
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.raspagemSubgengivais"
                    :validations="validations.raspagemSubgengivais"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.raspagemSubgengivais == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Raspagem alisamento subgengivais (por sextante)
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.restauracaoDentePermanenteAnterior"
                    :validations="validations.restauracaoDentePermanenteAnterior"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.restauracaoDentePermanenteAnterior == ''"
                />
            </rkm-col>
            <rkm-col cols="5">
                Restauração de dente permanente anterior
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria"
                    :validations="validations.selamentoProvisorioCavidadeDentaria"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria == ''"
                />
            </rkm-col>
            <rkm-col cols="5">Selamento provisório de cavidáde dentária</rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.tratamentoAlveolite"
                    :validations="validations.tratamentoAlveolite"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.tratamentoAlveolite == ''"
                />
            </rkm-col>
            <rkm-col cols="5">Tratamento de alveolite</rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-input
                    number
                    v-model="model.procedimentosQuantidade.ulotomiaUlectomia"
                    :validations="validations.ulotomiaUlectomia"
                    name="Quantidade"
                    :disabled="isDisabled  && model.procedimentosQuantidade.ulotomiaUlectomia == ''"
                />
            </rkm-col>
            <rkm-col cols="5">Ulotomia/Ulectomia</rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                acessoPolpaDentaria: this.model.procedimentosQuantidade.acessoPolpaDentaria == '' ? null : { max_value: 32},
                adaptacaoProteseDentaria: this.model.procedimentosQuantidade.adaptacaoProteseDentaria == '' ? null: { max_value: 32 },
                aplicacaoCariostatico: this.model.procedimentosQuantidade.aplicacaoCariostatico == '' ? null : { max_value: 32 },
                aplicacaoSelante: this.model.procedimentosQuantidade.aplicacaoSelante == '' ?  null : { max_value: 32 },
                aplicacaoTopicaFluor: this.model.procedimentosQuantidade.aplicacaoTopicaFluor == '' ? null : { max_value: 1 },
                capeamentoPulpar: this.model.procedimentosQuantidade.capeamentoPulpar == '' ? null : { max_value: 32 },
                cimentacaoProtese: this.model.procedimentosQuantidade.cimentacaoProtese == '' ? null : { max_value: 32 },
                curativoDemora: this.model.procedimentosQuantidade.curativoDemora == '' ? null : { max_value: 32 },
                drenagemAbscesso: this.model.procedimentosQuantidade.drenagemAbscesso == '' ? null : { max_value: 1 },
                evidenciacaoPlacaBacteriana: this.model.procedimentosQuantidade.evidenciacaoPlacaBacteriana == '' ? null : { max_value: 1 },
                exodontiaDenteDeciduo: this.model.procedimentosQuantidade.exodontiaDenteDeciduo == '' ? null : { max_value: 32 },
                exodontiaDentePermanente: this.model.procedimentosQuantidade.exodontiaDentePermanente == '' ? null : { max_value: 32 },
                instalacaoProteseDentaria: this.model.procedimentosQuantidade.instalacaoProteseDentaria == '' ? null: { max_value: 32 },
                moldagemProteseDentaria: this.model.procedimentosQuantidade.moldagemProteseDentaria == '' ? null : { max_value: 32 },
                orientacaoHigieneBucal: this.model.procedimentosQuantidade.orientacaoHigieneBucal == '' ? null : { max_value: 1 },
                remocaoPlacaBacteriana: this.model.procedimentosQuantidade.remocaoPlacaBacteriana == '' ? null : { max_value: 1 },
                pulpotomiaDentaria: this.model.procedimentosQuantidade.pulpotomiaDentaria == '' ? null : { max_value: 32 },
                raspagemSupragengivais: this.model.procedimentosQuantidade.raspagemSupragengivais == '' ? null : { max_value: 6},
                raspagemSubgengivais: this.model.procedimentosQuantidade.raspagemSubgengivais == '' ? null : { max_value: 6 },
                restauracaoDentePermanenteAnterior: this.model.procedimentosQuantidade.restauracaoDentePermanenteAnterior == '' ? null : { max_value: 32 },
                selamentoProvisorioCavidadeDentaria: this.model.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria == '' ? null : { max_value: 32 },
                tratamentoAlveolite: this.model.procedimentosQuantidade.tratamentoAlveolite == '' ? null : { max_value: 32 },
                ulotomiaUlectomia: this.model.procedimentosQuantidade.ulotomiaUlectomia == '' ? null : { max_value: 32 },
            }
        },
        isDisabled() {
            if(this.model.procedimentos.length + Object.entries(this.model.procedimentosQuantidade).filter(p => {
                return p[1] != ''
            }).length >= 20) {
                return true
            }
            return this.model.exportacao == 1
        }
    },
    props: {
        model: { type: Object, required: true}
    }
};
</script>
